import type { FaireProductEntity } from "../../entity_types/product";

export const p_s5trp6kcfk: FaireProductEntity = {
  token: "p_s5trp6kcfk",
  type: "product",
  name: "The Cr\u00e8me Shop Chococat Cocoa Butter Hand Cream ",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/a4d9a67bcfbf505acfcb9a422a1978888de2facac3376774a1e75a385f64ce32.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
